import { Wrap } from './styles';

import Icon from '@map/components/Icons';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { useState, useEffect, useRef} from 'react';

/**
 * Select
 * 
 * @param {number} id 
 * @param {number} width 
 * @param {*} value
 * @param {array} options
 * @param {function} onChange
 * @param {*} props Resto
 * 
 * @returns 
 */
export  const Select = ({ id, width, value, options = [], onChange, ...props }) => {

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    setOpen(false);
  };

  const handleChange = (option) => (e) => {
    setOpen(false);
    onChange && onChange(option);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
    useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Wrap>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          style={{width: width}}
        >
          <span>
            {value.label || ''}
          </span>
          <span className="chevron">
          <Icon
            i="map-chevrondown"
            style={{ top: 'auto', right: 12 }}
            {...props}
          />
        </span>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
          style={{
            width: width, 
            zIndex: 1701,
            color: "#5E5E5E"
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id={id}
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                  {options &&
                    options.map((option, i) => (
                      <MenuItem key={i} onClick={handleChange(option)}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Wrap>
  );
};

export default Select;